<template>
  <div id="sidenavSecExample">
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/">
        <icon
          name="dashboard"
          class="mr-2 w-4 h-4"
          :class="isUrl('') ? 'fill-white' : 'fill-gray-300 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-gray-300 group-hover:text-white'">
          Dashboard
        </div>
      </Link>
    </div>
    <div
      v-if="$page.props.auth.user?.can['manage_roles']"
      id="sidenavAdmin"
      class="relative mb-4">
      <a
        class="text-ellipsis hover:bg-blue-50 flex items-center py-4 h-12 whitespace-nowrap rounded cursor-pointer overflow-hidden transition duration-300 ease-in-out"
        @click="toggleSection('admin')">
        <icon name="master" class="mr-1 w-4 h-4 fill-gray-300" />
        <div class="text-bold text-gray-300 text-lg">Admin</div>
        <icon
          name="cheveron-down"
          class="ml-1 w-4 h-4 fill-gray-300 transition-transform duration-300"
          :class="{ 'rotate-180': openSection === 'admin' }" />
      </a>
      <ul
        v-show="openSection === 'admin'"
        class="relative">
        <Link class="group flex items-center pl-2 py-2" href="/roles">
          <icon
            name="users"
            class="mr-1 w-4 h-4"
            :class="isUrl('roles') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('roles') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Roles
          </div>
        </Link>
        <Link
          v-if="$page.props.auth.user?.can['manage_users']"
          class="group flex items-center pl-2 py-2"
          href="/users">
          <icon
            name="users"
            class="mr-1 w-4 h-4"
            :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Users
          </div>
        </Link>
      </ul>
    </div>
    <div id="sidenavSecEx1" class="relative mb-4">
      <a
        class="text-ellipsis hover:bg-blue-50 flex items-center py-4 h-12 whitespace-nowrap rounded cursor-pointer overflow-hidden transition duration-300 ease-in-out"
        @click="toggleSection('master')">
        <icon name="master" class="mr-1 w-4 h-4 fill-gray-300" />
        <div class="text-bold text-gray-300 text-lg">Master</div>
        <icon
          name="cheveron-down"
          class="ml-1 w-4 h-4 fill-gray-300 transition-transform duration-300"
          :class="{ 'rotate-180': openSection === 'master' }" />
      </a>
      <ul
        v-show="openSection === 'master'"
        class="relative">
        <Link class="group flex items-center pl-2 py-2" href="/employees">
          <icon
            name="users"
            class="mr-1 w-4 h-4"
            :class="isUrl('employees') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('employees') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Karyawan
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/organizations/1">
          <icon
            name="donor"
            class="mr-1 w-4 h-4"
            :class="isUrl('organizations/1') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('organizations/1') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Donor
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/organizations/2">
          <icon
            name="supplier"
            class="mr-1 w-4 h-4"
            :class="isUrl('organizations/2') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('organizations/2') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Supplier
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/organizations/3">
          <icon
            name="donatur"
            class="mr-1 w-4 h-4"
            :class="isUrl('organizations/3') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('organizations/3') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Donatur
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/contacts">
          <icon
            name="contact"
            class="mr-1 w-4 h-4"
            :class="isUrl('contacts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('contacts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Contacts
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/areaprojects">
          <icon
            name="users"
            class="mr-1 w-4 h-4"
            :class="isUrl('areaprojects') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('areaprojects') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Area Projects
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/itemlocations">
          <icon
            name="users"
            class="mr-1 w-4 h-4"
            :class="isUrl('itemlocations') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('itemlocations') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Item Locations
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/units">
          <icon
            name="users"
            class="mr-1 w-4 h-4"
            :class="isUrl('units') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('units') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Units
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/items">
          <icon
            name="users"
            class="mr-1 w-4 h-4"
            :class="isUrl('items') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('items') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Items
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/projects">
          <icon
            name="printer"
            class="mr-1 w-4 h-4"
            :class="isUrl('projects', 'projectactivities') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('projects', 'projectactivities') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Projects
          </div>
        </Link>
      </ul>
    </div>
    <div id="sidenavSecEx2" class="relative mb-4">
      <a
        class="text-ellipsis hover:bg-blue-50 flex items-center py-4 h-12 whitespace-nowrap rounded cursor-pointer overflow-hidden transition duration-300 ease-in-out"
        @click="toggleSection('transaksi')">
        <icon name="transaction" class="mr-1 w-4 h-4 fill-gray-300" />
        <div class="text-bold text-gray-300 text-lg">Transaksi</div>
        <icon
          name="cheveron-down"
          class="ml-1 w-4 h-4 fill-gray-300 transition-transform duration-300"
          :class="{ 'rotate-180': openSection === 'transaksi' }" />
      </a>
      <ul
        v-show="openSection === 'transaksi'"
        class="relative">
        <Link class="group flex items-center pl-2 py-2" href="/logistics">
          <icon
            name="printer"
            class="mr-1 w-4 h-4"
            :class="isUrl('logistics') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('logistics') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Sumbangan Logistik
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/purchases">
          <icon
            name="printer"
            class="mr-1 w-4 h-4"
            :class="isUrl('purchases') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('purchases') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Purchase Request
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/purchaseorders">
          <icon
            name="printer"
            class="mr-1 w-4 h-4"
            :class="isUrl('purchaseorders') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('purchaseorders') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Purchase Orders
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/porecv">
          <icon
            name="printer"
            class="mr-1 w-4 h-4"
            :class="isUrl('porecv') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('porecv') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Penerimaan Barang PO
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/stockouts">
          <icon
            name="printer"
            class="mr-1 w-4 h-4"
            :class="isUrl('stockouts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('stockouts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Pengeluaran Barang
          </div>
        </Link>
      </ul>
    </div>
    <div
      v-if="$page.props.auth.user?.can['manage_distribution']"
      id="sidenavDistribusi"
      class="relative mb-4">
      <a
        class="text-ellipsis hover:bg-blue-50 flex items-center py-4 h-12 whitespace-nowrap rounded cursor-pointer overflow-hidden transition duration-300 ease-in-out"
        @click="toggleSection('distribusi')">
        <icon name="distribusi" class="mr-1 w-4 h-4 fill-gray-300" />
        <div class="text-bold text-gray-300 text-lg">Distribusi</div>
        <icon
          name="cheveron-down"
          class="ml-1 w-4 h-4 fill-gray-300 transition-transform duration-300"
          :class="{ 'rotate-180': openSection === 'distribusi' }" />
      </a>
      <ul
        v-show="openSection === 'distribusi'"
        class="relative">
        <Link class="group flex items-center pl-2 py-2" href="/donationtypes">
          <icon
            name="donationtypes"
            class="mr-1 w-4 h-4"
            :class="isUrl('donationtypes') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('donationtypes') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Jenis Bantuan
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/disabilitiestypes">
          <icon
            name="disability-01"
            class="mr-1 w-4 h-4"
            :class="isUrl('disabilitiestypes') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('disabilitiestypes') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Jenis Disabilitas
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/sectors">
          <icon
            name="users"
            class="mr-1 w-4 h-4"
            :class="isUrl('sectors') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('sectors') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Sectors
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/packages">
          <icon
            name="distribution-packages"
            class="mr-1 w-4 h-4"
            :class="isUrl('packages') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('packages') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Paket
          </div>
        </Link>
        <Link class="group flex items-center pl-2 py-2" href="/assessments">
          <icon
            name="printer"
            class="mr-1 w-4 h-4"
            :class="isUrl('assessments') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('assessments') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Assessment
          </div>
        </Link>
      </ul>
    </div>
    <div
      v-if="$page.props.auth.user?.can['asset_events.read'] || $page.props.auth.user?.can['item_inv_types.read'] || $page.props.auth.user?.can['asset_groups.read'] || $page.props.auth.user?.can['item_assets.read']"
      id="sidenavInventaris"
      class="relative mb-4">
      <a
        class="text-ellipsis hover:bg-blue-50 flex items-center py-4 h-12 whitespace-nowrap rounded cursor-pointer overflow-hidden transition duration-300 ease-in-out"
        @click="toggleSection('inventaris')">
        <icon name="inventory" class="mr-1 w-4 h-4 fill-gray-300" />
        <div class="text-bold text-gray-300 text-lg">Inventaris</div>
        <icon
          name="cheveron-down"
          class="ml-1 w-4 h-4 fill-gray-300 transition-transform duration-300"
          :class="{ 'rotate-180': openSection === 'inventaris' }" />
      </a>
      <ul
        v-show="openSection === 'inventaris'"
        class="relative">
        <Link
          v-if="$page.props.auth.user?.can['asset_events.read']"
          class="group flex items-center pl-2 py-2"
          href="/asset_events">
          <icon
            name="asset-events"
            class="mr-1 w-4 h-4"
            :class="isUrl('asset_events') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('asset_events') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Asset Events
          </div>
        </Link>
        <Link
          v-if="$page.props.auth.user?.can['item_inv_types.read']"
          class="group flex items-center pl-2 py-2"
          href="/item_inv_types">
          <icon
            name="item-inv-types"
            class="mr-1 w-4 h-4"
            :class="isUrl('item_inv_types') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('item_inv_types') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Item Type
          </div>
        </Link>
        <Link
          v-if="$page.props.auth.user?.can['asset_groups.read']"
          class="group flex items-center pl-2 py-2"
          href="/asset_groups">
          <icon
            name="asset-groups"
            class="mr-1 w-4 h-4"
            :class="isUrl('assets_groups') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('asset_groups') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Asset Group
          </div>
        </Link>
        <Link
          v-if="$page.props.auth.user?.can['item_assets.read']"
          class="group flex items-center pl-2 py-2"
          href="/item_assets">
          <icon
            name="assets"
            class="mr-1 w-4 h-4"
            :class="isUrl('item_assets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div class="text-sm" :class="isUrl('item_assets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            Item Assets
          </div>
        </Link>
      </ul>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'

export default {
    components: {
        Icon,
        Link,
    },
    data () {
        return {
            openSection: null,
        }
    },
    mounted () {
        this.openSection = this.getCurrentSection()
    },
    methods: {
        isUrl (...urls) {
            let currentUrl = this.$page.url.substr(1)
            if (urls[0] === '') {
                return currentUrl === ''
            }
            return urls.filter((url) => currentUrl.startsWith(url)).length
        },
        toggleSection (section) {
            this.openSection = this.openSection === section ? null : section
        },
        getCurrentSection () {
            const urlSectionMap = {
                master: ['employees', 'organizations', 'contacts', 'areaprojects', 'itemlocations', 'units', 'items', 'projects'],
                transaksi: ['logistics', 'purchases', 'purchaseorders', 'porecv', 'stockouts'],
                distribusi: ['donationtypes', 'disabilitiestypes', 'sectors', 'packages', 'assessments'],
                inventaris: ['asset_events', 'item_inv_types', 'asset_groups', 'item_assets'],
                admin: ['roles', 'users'],
            }

            const currentUrl = this.$page.url.substr(1)

            for (const [section, prefixes] of Object.entries(urlSectionMap)) {
                if (prefixes.some(prefix => currentUrl.startsWith(prefix))) {
                    return section
                }
            }

            return null
        },
    },
}
</script>
